
import { KanbanSquare, List, Table, EyeIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface TaskViewToggleProps {
  view: 'cards' | 'table' | 'kanban';
  onViewChange: (view: 'cards' | 'table' | 'kanban') => void;
  showOldCompletedTasks?: boolean;
  onShowOldCompletedTasksChange?: (show: boolean) => void;
}

export const TaskViewToggle = ({ 
  view, 
  onViewChange, 
  showOldCompletedTasks = false,
  onShowOldCompletedTasksChange
}: TaskViewToggleProps) => {
  return (
    <div className="flex gap-2 items-center">
      <Button
        variant={view === 'cards' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onViewChange('cards')}
        className="flex items-center gap-1"
      >
        <List className="h-4 w-4" />
        <span className="hidden sm:inline">Cards</span>
      </Button>
      <Button
        variant={view === 'table' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onViewChange('table')}
        className="flex items-center gap-1"
      >
        <Table className="h-4 w-4" />
        <span className="hidden sm:inline">Table</span>
      </Button>
      <Button
        variant={view === 'kanban' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onViewChange('kanban')}
        className="flex items-center gap-1"
      >
        <KanbanSquare className="h-4 w-4" />
        <span className="hidden sm:inline">Kanban</span>
      </Button>
      
      {onShowOldCompletedTasksChange && (
        <div className="flex items-center space-x-2 ml-2">
          <Switch 
            id="show-old-tasks" 
            checked={showOldCompletedTasks}
            onCheckedChange={onShowOldCompletedTasksChange}
          />
          <Label htmlFor="show-old-tasks" className="text-sm flex items-center gap-1">
            <EyeIcon className="h-3 w-3" />
            <span className="hidden sm:inline">Show old completed tasks</span>
          </Label>
        </div>
      )}
    </div>
  );
};
